import Action from '../action';

// Retrieve from the server
export const FAVOURITES_FETCH_INITIATED = 'FAVOURITES_FETCH_INIT';
export const FAVOURITES_FETCH_SUCCESS = 'FAVOURITES_FETCH_SUCCESS';
export const FAVOURITES_FETCH_FAILED = 'FAVOURITES_FETCH_FAILED';

// Interact on the client
export const FAVOURITE_ADDED = 'FAVOURITE_ADDED';
export const FAVOURITE_ADD_SUCCESS = 'FAVOURITE_ADD_SUCCESS';
export const FAVOURITE_ADD_FAILED = 'FAVOURITE_ADD_FAILED';
export const FAVOURITE_REMOVED = 'FAVOURITE_REMOVED';
export const FAVOURITE_REMOVE_SUCCESS = 'FAVOURITE_REMOVE_SUCCESS';
export const FAVOURITE_REMOVE_FAILED = 'FAVOURITE_REMOVE_FAILED';
export const FAVOURITE_SELECTED = 'FAVOURITE_SELECTED';
export const FAVOURITE_AUDIT = 'FAVOURITE_AUDIT';
export const FAVOURITE_UPDATED = 'FAVOURITE_UPDATED';
export const FAVOURITE_UPDATE_SUCCESS = 'FAVOURITE_UPDATE_SUCCESS';
export const FAVOURITE_UPDATE_FAILED = 'FAVOURITE_UPDATE_FAILED';
export const FAVOURITE_RESTORE = 'FAVOURITE_RESTORE';
export const FAVOURITE_RESTORE_SUCCESS = 'FAVOURITE_RESTORE_SUCCESS';
export const FAVOURITE_RESTORE_FAILED = 'FAVOURITE_RESTORE_FAILED';
export const FAVOURITE_OLD_SELECTED = 'FAVOURITE_OLD_SELECTED';

export const favouriteAdd = favourite => Action(FAVOURITE_ADDED, favourite);
export const favouriteAddSuccess = favourite => Action(FAVOURITE_ADD_SUCCESS, favourite);
export const favouriteAddFailed = error => Action(FAVOURITE_ADD_FAILED, error, true);

export const audit = search => Action(FAVOURITE_AUDIT, search);

export const favouriteUpdate = favourite => Action(FAVOURITE_UPDATED, favourite);
export const favouriteUpdateSuccess = favourite => Action(FAVOURITE_UPDATE_SUCCESS, favourite);
export const favouriteUpdateFailed = error => Action(FAVOURITE_UPDATE_FAILED, error, true);

export const favouriteRemove = favourite => Action(FAVOURITE_REMOVED, favourite);
export const favouriteRemoveSuccess = favourite => Action(FAVOURITE_REMOVE_SUCCESS, favourite);
export const favouriteRemoveFailed = error => Action(FAVOURITE_REMOVE_FAILED, error, true);

export const favouriteFetch = () => Action(FAVOURITES_FETCH_INITIATED);
export const favouriteFetchSuccess = payload => Action(FAVOURITES_FETCH_SUCCESS, payload);
export const favouriteFetchFailed = payload => Action(FAVOURITES_FETCH_FAILED, payload, true);

export const favouriteSelect = favourite => Action(FAVOURITE_SELECTED, favourite);
export const selectOldFavourite = oldFavourite => Action(FAVOURITE_OLD_SELECTED, oldFavourite);

export const favouriteRestore = id => Action(FAVOURITE_RESTORE, id);
export const favouriteRestoreSuccess = favourite => Action(FAVOURITE_RESTORE_SUCCESS, favourite);
export const favouriteRestoreFailed = error => Action(FAVOURITE_RESTORE_FAILED, error, true);
